"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckBoxInputSize = void 0;
let CheckBoxInputSize = exports.CheckBoxInputSize = /*#__PURE__*/function (CheckBoxInputSize) {
  CheckBoxInputSize["large"] = "large";
  CheckBoxInputSize["medium"] = "medium";
  CheckBoxInputSize["small"] = "small";
  return CheckBoxInputSize;
}({});